import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ProjectState {
  projectTab: 'assets' | 'sounds' | 'projects' | string
}

const initialState: ProjectState = {
  projectTab: '',
}

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectTab: (state, action: PayloadAction<string>) => {
      state.projectTab = action.payload
    },
  },
})

export const { setProjectTab } = projectSlice.actions

export default projectSlice.reducer
